import { ArrowDown } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";
import type { Appointment, DailyTimelineLabels } from "./types";
import { diffMinutes, fmtTime } from "./utils";

interface NextAppointmentCtaProps {
  next: Appointment | null;
  now: Date;
  labels: DailyTimelineLabels;
  onClick: () => void;
}

export function NextAppointmentCta({ next, now, labels, onClick }: NextAppointmentCtaProps) {
  const done = !next;
  let text = labels.nextCtaDone;
  if (next) {
    const minutesUntil = diffMinutes(next.startTime, now);
    if (next.status === "in_progress" || (minutesUntil < 0 && next.endTime.getTime() > now.getTime())) {
      text = labels.nextCta({ time: fmtTime(next.startTime), minutes: 0 });
    } else if (minutesUntil < 0) {
      text = labels.nextCtaLate({ minutes: Math.abs(minutesUntil) });
    } else {
      text = labels.nextCta({ time: fmtTime(next.startTime), minutes: minutesUntil });
    }
  }

  return (
    <footer className="sticky bottom-0 z-20 px-3 py-3 bg-biz-bg/95 backdrop-blur border-t border-biz-border">
      <button
        type="button"
        onClick={onClick}
        disabled={done}
        aria-label={text}
        className={cn(
          "w-full inline-flex items-center justify-center gap-2 h-16 rounded-biz-btn font-display font-semibold text-base biz-motion-safe biz-focus-ring transition-all",
          done
            ? "bg-biz-muted text-biz-foreground-muted cursor-not-allowed"
            : "bg-biz-primary text-biz-primary-foreground biz-shadow-md hover:bg-biz-primary-hover active:scale-[0.98]",
        )}
      >
        {!done && <ArrowDown size={18} weight="regular" />}
        <span className="font-mono-num tracking-wider">{text}</span>
      </button>
    </footer>
  );
}
